import { ReactNode } from "react";
import styled from "styled-components";
import { colors } from "../app/styles";

type BannerTone = "warning" | "info" | "error";

const toneStyles: Record<
  BannerTone,
  { bg: string; border: string; text: string }
> = {
  warning: { bg: colors.warnBg, border: colors.warnBorder, text: colors.warnText },
  info: { bg: "#e6f4ff", border: "#91caff", text: "#0958d9" },
  error: { bg: "#fff1f0", border: "#ffa39e", text: "#a8071a" },
};

const Banner = styled.div<{ $tone: BannerTone }>`
  border: 1px solid ${(p: { $tone: BannerTone }) => toneStyles[p.$tone].border};
  background: ${(p: { $tone: BannerTone }) => toneStyles[p.$tone].bg};
  color: ${(p: { $tone: BannerTone }) => toneStyles[p.$tone].text};
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.35;
`;

interface StatusBannerProps {
  tone?: BannerTone;
  children: ReactNode;
}

export default function StatusBanner({
  tone = "warning",
  children,
}: StatusBannerProps) {
  return <Banner $tone={tone}>{children}</Banner>;
}
